import { round } from 'core/utils/number'

import { ContractedRateType } from 'contracts/domain/ContractedRateType'

export function getLoadOfferPriceBreakdown(loadOffer) {
  const { contract, price, load } = loadOffer
  const { fuel_surcharge, mileage } = load
  const isLHFSC = contract?.source?.rate_type === ContractedRateType.LineHaulFSC
  const fuelSurcharge = Number(fuel_surcharge)

  if (contract && fuelSurcharge && isLHFSC) {
    const haulPrice = price - fuelSurcharge
    return {
      haul: haulPrice,
      haulPerMile: mileage > 0 ? round(haulPrice / mileage, 2) : null,
      fuel: fuelSurcharge,
    }
  }

  return {
    haul: price,
    haulPerMile: mileage > 0 ? round(price / mileage, 2) : null,
    fuel: null,
  }
}
